export default __webpack_public_path__ + "static/media/available.f46492ca.png";